import { CountryState } from './index';
import { ActionTree } from 'vuex';
// @ts-ignore
import { IState } from "../index";
import { AxiosError, AxiosResponse } from "axios";
import { fetchCountries } from "@store/services/fetchCheckoutData";

export default {
    async initCountries({ state, commit, rootState }) {
        if (state.isInitialized) {
            return;
        }

        await fetchCountries(
            rootState.checkout.siteSettings.baseUrl,
            rootState.checkout.checkoutSettings.locale
        )
            .then((response: AxiosResponse) => {
                commit('setCountries', response.data);
                commit('setContactInfoCountry', response.data.default.name);
                commit('setContactInfoCountryIso2', response.data.default.iso2);
                commit('setContactInfoDialCode', response.data.default.dialCode);
                commit('isInitialized');
            })
            .catch((e: AxiosError) => {
                const responseStatus = e.response ? e.response.status : 'none';
                const message = `Error in initCountries | Error code: 1693824800 | HTTP status: ${responseStatus} | ${e.message}`;

                throw Error(message);
            });
    }
} as ActionTree<CountryState, IState>
